module.exports = __webpack_public_path__ + "img/TeamComic_010.b5a6c168.png";